import React from "react";
import PropTypes from "prop-types";
import {
  Alert,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { adminDataTableHeadSmallSx } from "../../../../utils/adminTableScrollSx";

const NewsletterHistoryErrorsTable = ({ errors }) => {
  if (!errors?.length) {
    return (
      <Typography variant="body2" color="text.secondary">
        Nessun errore registrato per questa pubblicazione.
      </Typography>
    );
  }

  const hasGlobalError = errors.some((item) => item.recipient === "all");

  return (
    <Box>
      {hasGlobalError ? (
        <Alert severity="error" sx={{ mb: 2 }}>
          Errore globale campagna: l&apos;invio non è stato completato per tutti i destinatari.
        </Alert>
      ) : null}
      <TableContainer sx={{ border: "1px solid #e2e8f0", borderRadius: 1 }}>
        <Table size="small">
          <TableHead sx={adminDataTableHeadSmallSx}>
            <TableRow>
              <TableCell>Destinatario</TableCell>
              <TableCell>Errore</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {errors.map((item, index) => (
              <TableRow
                key={`${item.recipient}-${index}`}
                sx={item.recipient === "all" ? { bgcolor: "#fef2f2" } : undefined}
              >
                <TableCell sx={{ fontWeight: item.recipient === "all" ? 700 : 400 }}>
                  {item.recipient === "all" ? "Tutti (errore globale)" : item.recipient}
                </TableCell>
                <TableCell>{item.error}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

NewsletterHistoryErrorsTable.propTypes = {
  errors: PropTypes.arrayOf(
    PropTypes.shape({
      recipient: PropTypes.string.isRequired,
      error: PropTypes.string.isRequired,
    })
  ),
};

export default NewsletterHistoryErrorsTable;
